<template>
  <div class="agent_list_style batch_btn" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Select v-model="employeeNum" filterable clearable placeholder="请选择操作人员" title="操作人员" class="countdown_select">
          <Option v-for="(option, index) in employeeList" :value="option.id" :key="index">{{option.employeeName}}</Option>
        </Select>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="导出开始时间" end-placeholder="导出结束时间"
                        align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:19%;">操作人员</th>
            <th class="font_style_set" style="width:19%;">导出时间</th>
            <th class="font_style_set" style="width:19%;">导出模块</th>
            <th class="font_style_set" style="width:19%;">导出状态</th>
            <th class="font_style_set" style="width:24%;border-right: 0px">操作</th>
          </tr>
        </table>
      </div>
      <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
        <table class="table_head_footer">
          <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td  style="width:19%;">{{item.employeeName}}</td>
            <td  style="width:19%;">{{item.createTime}}</td>
            <td  style="width:19%;">{{item.description}}</td>
            <td  style="width:19%;">{{item.successNum=='0'?'正在下载':'已下载'}}</td>
            <td class="template_table_btn" style="width:24%;">
              <span v-if="roleList['3_8-1']">
                <a :href="downUrl+item.addr" class="search_btn" target="_blank" v-if="item.addr">下载</a>
                <a :href="downUrl+item.addr" class="search_btn" target="_blank" v-if="!item.addr" title="任务导出失败" style="cursor: not-allowed">下载</a>
              </span>
              <span class="search_btn" @click="deleteImport(item.id)" v-if="roleList['3_8-2']">删除</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "DownLoadTask",
    mixins:[publicFunClass],
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        total:0,
        editable:false,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        speedChangePage: 1,
        downUrl:this.baseURL+'common/downloadFile.json?type=0&addr=',
        pageSize:20,
        employeeCode:'',
        starEndTime:'',
        screenHeight:{height:''},
        tableHeight:{height:''},
        spinShow: true,
        infoTableList:[],
        roleList:JSON.parse(localStorage.getItem("roleList")),
        employeeNum:'',
        employeeList:[],
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
      }
    },
    methods:{
      deleteImport:function(id){
        let journalType="系统管理=>导出批次=>删除";
        let menuId="3_8-2";
        let param={
          journalType:journalType,
          menuId:menuId,
          id:id
        };
        let that=this;
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("downloadDetail/doDelete.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("删除成功");
              that.initSearch();
            })
          }
        });
      },
      initSearch:function () {
        let that=this;
        this.spinShow=true;
        let param={
          createTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
          employeeId:this.employeeNum,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"系统管理=>导出批次查询",
          menuId:"null"
        };
        this.$http.post("downloadDetail/toIndex.json",param) .then(function (res) {
          that.spinShow=false;
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          let obj=res.data.obj;
          that.infoTableList=obj.list.content;
          that.total=res.data.obj.list.totalSize;
          that.employeeList=res.data.obj.employeeList;
        });
      },
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      this.tableHeight.height=this.mountHeight(225);
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='3_8' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DownLoadTask.vue